import React, { Component } from 'react'
import RoundCard from '../../../Components/RoundCard'
import FieldTypes from './FieldTypes'
import InputField from './InputField'

export default class BDNew extends Component {

    constructor(props) {
        super(props)

        this.state = {
            pageFields: [],
            formData: {},
            fieldEvents: {
                onChange: this.onChange
            },
            files: {}
        }
    }

    componentDidMount() {
        const { pageFields } = this.props
        const allFields = pageFields.sort((a, b) => { return ((a.newDisplayOrder || 0) - (b.newDisplayOrder || 0)) })
        const defaultData = this.getDefaultData(allFields)
        this.setState({
            pageFields: allFields,
            formData: defaultData
        })
    }

    getDefaultData = (allFields) => {
        let defaultData = {}
        allFields.forEach((item, idx) => {

            switch (item.type) {
                case FieldTypes.radiolist:
                    defaultData[item.id] = item?.options[0]?.id
                    break
                case FieldTypes.dropdown:
                    defaultData[`${item.id}Key`] = ''
                    defaultData[item.id] = ''
                    break
                default:
                    defaultData[item.id] = ''
                    break
            }
        })
        return defaultData;
    }

    onChange = (e) => {
        let { formData, files } = this.state
        switch (e.target.getAttribute('fieldtype')) {
            case FieldTypes.singleImage:
                files[e.target.id] = e.target.files[0]
                break;
            case FieldTypes.dropdown:
                try {
                    formData[`${e.target.id}Key`] = e.target.value
                    formData[e.target.id] = e.target.selectedOptions[0].innerText
                } catch (err) {
                    formData[e.target.id] = ''
                }
                break;
            case FieldTypes.radiolist:
                formData[e.target.name] = e.target.id
                break;
            default:
                formData[e.target.id] = e.target.value
                break;
        }
        this.setState({
            formData
        })
    }

    resetForm = () => {
        const { pageFields } = this.props
        const defaultData = this.getDefaultData(pageFields)
        this.setState({
            formData: defaultData,
            files: {}
        })
    }

    render() {
        const { pageFields, formData, fieldEvents } = this.state


        return (
            <RoundCard className='bd-new addteacher' scaleOnHover={false}>
                <div className="form">
                    {
                        pageFields.map((item, idx) => {
                            return (
                                <InputField
                                    key={idx}
                                    fieldModel={item}
                                    fieldEvents={fieldEvents}
                                    value={formData[item.id]}
                                />
                            )
                        })
                    }
                </div>
            </RoundCard>
        )
    }
}
